import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { explicitNull, or } from '@common/tempAirbnbPropTypesReplacement';
import { MOBILE_APP_USER_AGENT_REGEX } from '@common/constants/mobileApp';

const UserAgentContext = createContext('');

UserAgentContext.displayName = 'UserAgentContext';

export const UserAgentProvider = ({ children, userAgent }) => (
  <UserAgentContext.Provider
    value={{
      userAgent,
      isMobileApp: MOBILE_APP_USER_AGENT_REGEX.test(userAgent),
    }}
  >
    {children}
  </UserAgentContext.Provider>
);

UserAgentProvider.propTypes = {
  children: PropTypes.node.isRequired,
  userAgent: or([PropTypes.string, explicitNull()]).isRequired,
};

export const useUserAgent = () => useContext(UserAgentContext);
